import Client from '../HttpClient';

const list = () => {
	return Client.get('/admin/api/printer-device');
};

const create = (payload) => {
	return Client.post(`/admin/api/printer-device`, payload);
};

const find = (printerNo) => {
	return Client.get(`/admin/api/printer-device/${printerNo}`);
};

const update = (printerNo, payload) => {
	return Client.put(`/admin/api/printer-device/${printerNo}`, payload);
};

const remove = (printerNo) => {
	return Client.del(`/admin/api/printer-device/${printerNo}`);
};

const test = (payload) => {
	return Client.post(`/admin/api/printer-device/print-test-page`, payload);
};

const updateConfig = (payload) => {
	return Client.put(`/admin/api/printer-device`, payload);
};

const listPrinterManifest = () => {
	return Client.get(`/admin/api/printer-device/printer-manifest`);
};

const listInstalledPrinters = () => {
	return Client.get(`/admin/api/printer-device/installed-printers`);
};

export default {
	list,
	find,
	create,
	update,
	remove,
	test,
	updateConfig,
	listPrinterManifest,
	listInstalledPrinters,
};
